import * as React from 'react';
import { connect } from 'react-redux';
import './PersonalInfo.css';
import { ProgressBar, Form, Button } from 'react-bootstrap';
import { validateEmail, validateName, validateSurname, validateCellphoneNumber } from '../../../constants/validation';
import { setPersonalInfo } from '../../../actions/salesActions';
import { navigateTo } from '../../../actions/navigationActions';
import { DASHBOARD } from '../../../routes/routes';

class PersonalInfo extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            email: this.props.profile.email,
            firstname: this.props.profile.name,
            surname: this.props.profile.surname,
            phone: this.props.profile.cellphoneNumber,
            submitted: false,
            mailRegex: true,
            nameRegex: true,
            surnameRegex: true,
            phoneRegex: true,
            nextDisabled: true,
            hide: true,
            desktopTCs: false,
            loggedIn: this.props.auth.uid ? true : false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeNumbers = this.handleChangeNumbers.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleSwitch = this.handleSwitch.bind(this);
        this.checkSubmit = this.checkSubmit.bind(this);
        this.handleBack = this.handleBack.bind(this);
    }

    async componentDidMount() {
        if (this.props.profile.isLinked !== true) {
            await this.setState({
                email: "",
                firstname: "",
                surname: "",
                phone: "",
            });
        }
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
        await this.checkSubmit();
    }

    async handleChangeNumbers(e: any) {
        let name = e.target.name;
        let value = await e.target.value.replace(/[^0-9]/gi, "");
        value = value.length < 10 ? value :value.substring(0, 10);
        await this.setState({ [name]: value })
        await this.checkSubmit();
    }

    async handleBlur(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        if (name === "firstname") {
            await this.setState({ nameRegex: validateName.test(value) });
        } else if (name === "surname") {
            await this.setState({ surnameRegex: validateSurname.test(value) });
        } else if (name === "phone") {
            await this.setState({ phoneRegex: validateCellphoneNumber.test(value) });
        } else if (name === "email") {
            await this.setState({ mailRegex: (value !== "" ? validateEmail.test(value) : true) });
        }
    }

    async checkSubmit() {
        const { email } = this.state;
        const { firstname } = this.state;
        const { surname } = this.state;
        const { phone } = this.state;
        const { desktopTCs } = this.state;

        if (validateName.test(firstname) && validateSurname.test(surname) && validateCellphoneNumber.test(phone) && (email !== "" ? validateEmail.test(email) : true)) {
            await this.setState({ nextDisabled: false });
        } else {
            await this.setState({ nextDisabled: true });
        }

    }

    async handleSwitch(e: any) {
        //var checked = e.target.checked;
        //await this.setState({ desktopTCs: checked });
        await this.checkSubmit();
    }

    handleRedirect(nextPage: string) {
        this.props.redirectTo(nextPage);
    }

    handleClick() {
        this.props.dispatchSetPersonalInfo(this.state.firstname, this.state.surname, this.state.phone, this.state.email)
    }

    async handleBack(e: any) {
        this.props.redirectTo(DASHBOARD)
    }

    public render() {
        const { email, firstname, surname, phone, submitted, mailRegex, nameRegex, phoneRegex, surnameRegex } = this.state;
        const quoteType = this.props.sales.quoteType;
        return (
            <div className={this.state.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-0 logged-out"}>
                <div className="col-12 mt-4 pb-4 text-lg-center text-md-center">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={10} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="ssp-addportable-possessions-crown-icon mt-0px text-center">
                                    <div className="ssp-sales-journey-crown-icon" title="Add portable possessions"></div>
                                </div>
                                {quoteType !== "PRODUCT_BLING" ? <div className="mt-21px mobile-mt-17px">
                                    <p className="mt-4 mb-1 text-center Lets-get-to-know-ea">Let's get to know each other... Please fill in your details below.</p>
                                    <p className="text-center Lets-get-to-know-ea mb-0px">(This conversation is 100% private. Promise.)</p>
                                </div> : <div className="mt-21px mobile-mt-17px mb-30px"><div className="mb-0px font-size-16px font-weight-500 text-center">Shweet, please fill in the policyholder's personal info</div></div>}
                                
                                <div className="form-row mb-lg-1 mb-20px mobile-mb-0px">
                                    <div className="col-12 col-lg-6 mb-2 mb-lg-0">
                                        <div className={'form-group mobile-mb-20px' + (submitted && !firstname ? ' has-error' : '')}>
                                            <Form.Label className={'left-align temp-text-box-label pl-1 line-height-normal mb-6px' + (this.state.firstname !== "" ? "" : " no-opacity")}>Name</Form.Label>
                                            <Form.Control type="text" placeholder="Name" id="PersonalInputName" name="firstname" value={this.state.firstname} onChange={this.handleChange} onBlur={this.handleBlur} />
                                            <div className="help-block">
                                                {!nameRegex ? <div>First name must be 3 characters or more</div> : null}
                                            </div>
                                            {submitted && !firstname &&
                                                <div className="help-block">First name is required</div>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <div className={'form-group mobile-mb-20px' + (submitted && !surname ? ' has-error' : '')}>
                                            <Form.Label className={'left-align temp-text-box-label pl-1 line-height-normal mb-6px' + (this.state.surname !== "" ? "" : " no-opacity")}>Surname</Form.Label>
                                            <Form.Control type="text" placeholder="Surname" name="surname" value={this.state.surname} onChange={this.handleChange} onBlur={this.handleBlur} />
                                            <div className="help-block">
                                                {!surnameRegex ? <div>Surname name must be 3 characters or more</div> : null}
                                            </div>
                                            {submitted && !surname &&
                                                <div className="help-block">Surname is required</div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="col-12 col-lg-6 mb-2 mb-lg-0">
                                        <div className={'form-group mobile-mb-20px' + (submitted && !phone ? ' has-error' : '')}>
                                            <Form.Label className={'left-align temp-text-box-label pl-1 line-height-normal mb-6px' + (this.state.phone !== "" ? "" : " no-opacity")}>Phone no.</Form.Label>
                                            <Form.Control type="tel" placeholder="Phone no." name="phone" value={this.state.phone} onChange={this.handleChangeNumbers} onBlur={this.handleBlur} />
                                            <div className="help-block">
                                                {!phoneRegex ? <div>Whoops, this phone no. is invalid</div> : null}
                                            </div>
                                            {submitted && !phone &&
                                                <div className="help-block">Whoops, this phone no. is invalid</div>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <div className={'form-group mb-0px' + (submitted && !email ? ' has-error' : '')}>
                                            <Form.Label className={'left-align temp-text-box-label pl-1 line-height-normal mb-6px' + (this.state.email !== "" ? "" : " no-opacity")}>Email</Form.Label>
                                            <Form.Control type="email" placeholder="Email" name="email" value={this.state.email} onChange={this.handleChange} onBlur={this.handleBlur} />
                                            <div className="help-block">
                                                {!mailRegex ? <div>Whoops, this email address is invalid</div> : null}
                                            </div>
                                            {submitted && !email &&
                                                <div className="help-block">Whoops, this email address is invalid</div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-center mt-40px">
                                    <div className="col-lg-4 col-md-4 nopa col-xs-12 col-sm-12 personal-info-button-holder">
                                        <Button className="btn btn-block btn-solid-red button-width" id="submitButton" disabled={this.state.nextDisabled} onClick={this.handleClick}>Next</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        dispatchSetPersonalInfo: (name: any, surname: any, phone: any, email: any) => dispatch(setPersonalInfo(name, surname, phone, email))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfo);